import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import Footer from '@/components/Footer';

// Shared layout for legal documents. `sections` = [{ title, blocks: [string | {list:[...]}, {table:{head:[], rows:[[]]}}] }]
export default function LegalPage({ title, updated, intro, sections, testId }) {
  const navigate = useNavigate();
  useEffect(() => { window.scrollTo(0, 0); }, []);

  const renderBlock = (b, i) => {
    if (typeof b === 'string') return <p key={i}>{b}</p>;
    if (b.list) return <ul key={i} className="list-disc pl-6 space-y-1">{b.list.map((li, j) => <li key={j}>{li}</li>)}</ul>;
    if (b.note) return <p key={i} className="bg-gray-50 border-l-4 border-black px-4 py-3 text-sm">{b.note}</p>;
    if (b.table) return (
      <div key={i} className="overflow-x-auto">
        <table className="w-full text-sm border-collapse">
          <thead><tr>{b.table.head.map((h, j) => <th key={j} className="text-left border-b-2 border-black py-2 pr-4 font-bold">{h}</th>)}</tr></thead>
          <tbody>{b.table.rows.map((r, j) => <tr key={j} className="border-b border-gray-200 align-top">{r.map((c, k) => <td key={k} className="py-2 pr-4">{c}</td>)}</tr>)}</tbody>
        </table>
      </div>
    );
    return null;
  };

  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid={testId}>
      <div className="max-w-4xl mx-auto px-4 py-12 flex-1 w-full">
        <Button onClick={() => navigate('/')} className="mb-8 bg-black text-white hover:bg-gray-800" data-testid={`${testId}-back-btn`}>
          ← Back to Home
        </Button>
        <h1 className="text-4xl font-bold text-black mb-4">{title}</h1>
        <p className="text-sm text-gray-600 mb-8">Last updated: {updated}</p>
        <div className="prose prose-lg max-w-none space-y-6 text-gray-700">
          {intro && intro.map(renderBlock)}
          {sections.map((s, i) => (
            <section key={i}>
              <h2 className="text-2xl font-bold text-black mt-8 mb-4">{s.title}</h2>
              <div className="space-y-3">{s.blocks.map(renderBlock)}</div>
            </section>
          ))}
          <section>
            <h2 className="text-2xl font-bold text-black mt-8 mb-4">Legal documents</h2>
            <div className="flex flex-wrap gap-3 text-sm">
              <a href="/privacy" className="underline">Privacy Policy</a>
              <a href="/terms" className="underline">Terms of Service</a>
              <a href="/dpa" className="underline">Data Processing Agreement</a>
              <a href="/subprocessors" className="underline">Subprocessors</a>
              <a href="/data-deletion" className="underline">Data Deletion</a>
              <a href="/cookie-policy" className="underline">Cookie Policy</a>
              <a href="/legal-notice" className="underline">Legal Notice</a>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
}
